
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.25 9.167a2.81 2.81 0 01-2.063-.855 2.81 2.81 0 01-.854-2.062c0-.806.285-1.493.854-2.063a2.81 2.81 0 012.063-.854 2.81 2.81 0 012.062.854c.57.57.855 1.257.855 2.063a2.81 2.81 0 01-.855 2.062 2.81 2.81 0 01-2.062.855zm0-1.667c.347 0 .642-.122.885-.365s.365-.538.365-.885-.122-.642-.365-.886A1.205 1.205 0 006.25 5c-.347 0-.642.121-.885.364A1.205 1.205 0 005 6.25c0 .347.122.642.365.885s.538.365.885.365zm7.5 9.167a2.81 2.81 0 01-2.063-.855 2.81 2.81 0 01-.854-2.062c0-.806.285-1.493.854-2.063a2.81 2.81 0 012.063-.854 2.81 2.81 0 012.063.854c.569.57.854 1.257.854 2.063a2.81 2.81 0 01-.855 2.062 2.81 2.81 0 01-2.062.855zm0-1.667c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.886a1.205 1.205 0 00-.885-.364c-.347 0-.642.121-.885.364a1.205 1.205 0 00-.365.886c0 .347.121.642.365.885.243.243.538.365.885.365zM4.5 16.667L3.333 15.5 15.5 3.333 16.667 4.5 4.5 16.667z"}})])
          )
        }
      }
    